export default __webpack_public_path__ + "static/experienceImg3-1d28ccf24dd38ebca24c7d964f453c6b.webp";